import Paper from '@mui/material/Paper';
import { Box } from '@mui/material';
import { BoxSelector } from '../../component/BoxSelector';
import { ContextSelect } from '../../component/ContextSelect';
import { useRef, useState } from 'react';
import { CustomerSelector } from '../../component/CustomerSelector';
import { SubmitButton } from '../../component/SubmitButton';
import { boxStatus } from '../../enum/boxStatus';
import { customerRole } from '../../enum/customerRole';
import useAlert from '../../component/Alert/useAlert';
import BoxAPI from '../../services/box.api.service';
import Title from '../../component/Title';


const NftBurning = () => {
    const {showSuccessAlert, showErrorAlert} = useAlert();
    const [state, setState] = useState({
        context: '',
        customer: '',
        box: '',
    });

    const changeState = partialState => setState(currentState => ({...currentState, ...partialState}));
    const startLoading = () => changeState({loading: true});
    const stopLoading = () => changeState({loading: false});

    const form = useRef(null);

    const handleSubmit = () => {
        startLoading();
        BoxAPI
            .burn(state.box.hash, state.customer.id)
            .then(() => {
                showSuccessAlert('NFT successfully burned');
                changeState({box: ''});
            })
            .catch(err => showErrorAlert(err.response.data.message))
            .finally(() => stopLoading());
    }

    return (
        <Paper sx={{p: 4, display: 'flex', flexDirection: 'column', alignItems: 'left'}}>
            <Box
                component="form"
                noValidate={false}
                sx={{width: '100%'}}
                ref={form}
            >
                <ContextSelect onContextChange={context => changeState({context})}/>
                <CustomerSelector
                    context={state.context}
                    roles={[customerRole.producer]}
                    onCustomerSelect={customer => changeState({customer})}
                />
                <Title sx={{mb: 1, mt: 2}}>Select a specific NFT</Title>
                <BoxSelector
                    customer={state.customer}
                    selectedBox={state.box}
                    onBoxChange={box => changeState({box})}
                    boxStatus={boxStatus.frozen}
                    searchByLotCustomer={true}
                />
                <SubmitButton
                    text="BURN"
                    loading={state.loading}
                    disabled={state.loading || !state.box}
                    handleSubmit={handleSubmit}
                />
            </Box>
        </Paper>
    );
};

export default NftBurning;
